export default function RailListController(
    $scope,
    $controller,
    flightsFactory
) {
    'ngInject';

    $controller('railListBaseCtrl', {
        $scope,
        flightsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/controllers/ukrailListCtrl.js